import { useUneeqState } from 'uneeq-react-core'
import React from 'react'
import { VideoInformation } from '../OnScreenInfo/InformationContent'

interface VideoProps {
  item: VideoInformation
}

const Video: React.FC<VideoProps> = ({ item }) => {
  const { expandedInfo } = useUneeqState()
  return (
    <iframe
      src={`${item.source}?autopause=true&byline=false&keyboard=false&playsinline=false&portrait=false&title=false&transparent=false&texttrack=en`}
      width={item.width || expandedInfo ? '100%' : '100%'}
      height={item.height || expandedInfo ? '320' : '320'}
      frameBorder={0}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  )
}

export default Video
